module.exports = __webpack_public_path__ + "img/star vista.96951caf.jpg";